import { Header } from "../../models/Header";
import {
  aVenir,
  dateDebut,
  dateEntree,
  dateFin,
  dateSortie,
  description,
  indicateur,
  jrDemo,
  p2,
  p2ParJour,
  planoPlateau,
  planoQte,
  produit,
  qte,
  qteMinEntrepot,
  qteMinPlancher,
  remplacer,
  statut,
  surPlancher,
  ventes,
} from "./columns";

export const planoProduitHeaders: Header[] = [
  {
    ...indicateur,
    width: "20",
  },
  {
    ...produit,
    fieldFormat: "",
    width: "100",
  },
  planoQte,
  {
    ...description,
    field: "produit.modele.mod_descr",
    width: "250",
  },
  {
    field: "fini_aff",
    fieldLabel: "Fini",
    fieldFormat: "",
    tooltip: "",
    isDisplayed: true,
    customCell: "",
    width: "150",
  },
  statut,
  {
    ...ventes,
    field: "stats.planost_ventes",
  },
  qte,
  {
    ...p2,
    field: "calcPlano.pcarre",
  },
  {
    ...p2ParJour,
    field: "stats.ventes_jr_p2",
    isDisplayed: true,
  },
  dateDebut,
  {
    ...dateFin,
    isDisplayed: true,
  },
  dateEntree,
  dateSortie,
  {
    ...jrDemo,
    field: "calcPlano.nbr_jr_demo",
  },
  {
    ...surPlancher,
    field: "calcPlano.sur_plancher",
  },
  {
    ...qteMinPlancher,
    field: "calcPlano.prodmin_qte_min",
  },
  {
    ...qteMinEntrepot,
    field: "calcPlano.prodmin_qte_bs",
  },
  aVenir,
  planoPlateau,
  remplacer
];
